import {
  Box,
  Button,
  Collapse,
  Divider,
  Grid,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import expandIcon from "../../../../assets/icons/expandDown.svg";
import shrinkIcon from "../../../../assets/icons/expandUp.svg";
import TextFieldInput from "../../../../components/TextFieldInput";
import { formatNumberIndian } from "../../../../utilis/common-funtions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  createRazorpayOrder,
  verifyVoucherPayment,
  getVoucherById,
} from "../../voucher-form.slice";
import { useParams } from "react-router-dom";
import { useRazorpayPayment } from "../../components/payments/useRazorpayPayment";
import { useFormik } from "formik";
import { FORM_PHASE, GATEWAY } from "../../../../config/constant";
import * as Yup from "yup";
import { useEasebuzzPayment } from "../payments/useEasebuzzPayment";
import PaymentFailedModal from "../../../new-booking-form/Individual-components/PaymentFailedModal";

const PaymentStatus = () => {
  const paymentStatusformik = useFormik({
    initialValues: {
      amount: "",
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please enter amount in field to Pay")
    })
  });

  const [open, setOpen] = useState(true);
  const [paymentAmount, setPaymentAmount] = useState("");
  const { applicantData } = useSelector((state) => state.voucherForm);
  const dispatch = useDispatch();
  const { voucherId } = useParams();
  const {
    initiatePayment,
    paymentResponse,
  } = useRazorpayPayment();
  const { initiateEasebuzzPayment, paymentResponse:easebuzzPaymentResponse } = useEasebuzzPayment()
    const [openPaymentFailedModal,setOpenPaymentFailedModal] = useState(false)
    const [failedAmount,setFailedAmount]= useState('')
  
    // eslint-disable-next-line no-unused-vars
    const [verifying, setVerifying] = useState(false);
  
  
  const handleEasebuzzPay = async (amount) => {
          await paymentStatusformik.validateForm();
          paymentStatusformik.setTouched({ amount: true });
          if(!amount) return
        try {
          const orderRes = await dispatch(
            createRazorpayOrder({
              amount,
              entityType: "voucher",
              entityId:applicantData?.id?.toString(),
              projectId:applicantData?.campaignId,
              gateway: GATEWAY?.EASEBUZZ,
              
              redirectUrl: window.location.href,
               notes: {
              productInfo: applicantData?.uniqueReferenceId,
              voucherId: voucherId,
              voucherAmount: Number(PaymentObject?.amountPayable),
              guest: {
                name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
                email: applicantData?.applicant1?.personalDetails?.emailAddress,
                phone: applicantData?.applicant1?.personalDetails?.contactNumber,
              },
            },
            })
          ).unwrap();
    
          const orderAccessKey = orderRes.accessKey;
    
          if (!orderAccessKey) {
            throw new Error(
              "Backend did not return access_key. Check createRazorpayOrder response: " +
                JSON.stringify(orderRes)
            );
          }
    
          await initiateEasebuzzPayment({
            orderAccessKey,
            easebuzzKey:orderRes?.easebuzzKey
          });
  
        } catch (err) {
          setFailedAmount(amount);
          setOpenPaymentFailedModal(true);
          console.error("Failed to initiate payment:", err);
        }
  
      };
  

  function extractPaymentDetails(data) {
    // Fallback to 0 if not provided
    const amountPayable = Number(data?.amountPayable) || 0;

    // Prefer `totalAmountPaid` if exists, else sum from transactions
    let amountPaid = Number(data?.totalAmountPaid) || 0;

    // Ensure non-negative due
    let amountDue = amountPayable - amountPaid;
    if (amountDue < 0) amountDue = 0;

    return {
      amountPayable,
      amountPaid,
      amountDue,
    };
  }

  const PaymentObject = extractPaymentDetails(applicantData?.paymentDetails);

  useEffect(() => {
    if (!paymentResponse) return;

    let attempts = 0;
    let isVerified = false;
    setFailedAmount('');

    const verifyPayment = async () => {
      if (attempts === 0) setVerifying(true); // start loading
      attempts++;

      const res = await dispatch(
        verifyVoucherPayment({
          orderId: paymentResponse?.razorpay_order_id,
          paymentId: paymentResponse?.razorpay_payment_id,
          signature: paymentResponse?.razorpay_signature,
          gateway: GATEWAY?.RAZORPAY,
          clientResponse:JSON.stringify(paymentResponse)
        })
      );

      if (res?.payload?.status === "success") {
        isVerified = true;
        dispatch(getVoucherById(`/${voucherId}`));
        setPaymentAmount("");
        paymentStatusformik?.resetForm();
      } else if (attempts < 3 && !isVerified) {
        // retry after short delay
        setTimeout(verifyPayment, 2000);
      } else {
        // stop loading after all attempts fail
        setVerifying(false);
      }
    };

    verifyPayment();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentResponse]);
  const handleRazorPay = async (amount) => {
    await paymentStatusformik.validateForm();
    paymentStatusformik.setTouched({ amount: true });
    try {
      // 1. Create order
      const orderRes = await dispatch(
      createRazorpayOrder({
          amount: amount,
          entityType: "voucher",
          entityId: applicantData?.id?.toString(),
          projectId:applicantData?.campaignId,
          gateway: GATEWAY?.RAZORPAY,
          notes: {
            voucherId: voucherId,
            voucherAmount: Number(PaymentObject?.amountPayable),
            productInfo: applicantData?.uniqueReferenceId,
            guest: {
              name: `${applicantData?.applicant1?.personalDetails?.firstName} ${applicantData?.applicant1?.personalDetails?.lastName}`.trim(),
              email: applicantData?.applicant1?.personalDetails?.emailAddress,
              phone: applicantData?.applicant1?.personalDetails?.contactNumber,
            },
          },
        })
      ).unwrap();
      // 2. Open Razorpay popup
      initiatePayment({
        amount: orderRes?.razorpayOrder?.amount,
        currency: orderRes?.razorpayOrder?.currency,
        orderId: orderRes?.razorpayOrder?.id,
        name: "Puravankara",
        description: "Payment",

        prefill: {
          name: orderRes?.razorpayOrder?.notes?.guest?.name,
          email: orderRes?.razorpayOrder?.notes?.guest?.email,
          contact: orderRes?.razorpayOrder?.notes?.guest?.phone,
        },
        razorpayKey: orderRes?.razorpayKey,
      });
    } catch (err) {
      console.error("Payment failed:", err);
    }
  };
  useEffect(() => {
      if (!easebuzzPaymentResponse) return;
  
      if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "failure") {
        setFailedAmount(easebuzzPaymentResponse?.amount)
        setOpenPaymentFailedModal(true)
        return;
      }
      let attempts = 0;
      let isVerified = false;
      setFailedAmount('');
  
      const verifyPayment = async () => {
        if (attempts === 0) setVerifying(true); // start loading
        attempts++;
  
        const res = await dispatch(
          verifyVoucherPayment({
            orderId: easebuzzPaymentResponse?.txnid,
            paymentId: easebuzzPaymentResponse?.easepayid,
            signature: easebuzzPaymentResponse?.hash,
            gateway: GATEWAY?.EASEBUZZ,
            clientResponse:JSON.stringify(easebuzzPaymentResponse)
          })
        );
  
        if (res?.payload?.status === "success") {
          isVerified = true;
          dispatch(getVoucherById(`/${voucherId}`));
          setPaymentAmount("");
          paymentStatusformik?.resetForm();
        } else if (attempts < 3 && !isVerified) {
          // retry after short delay
          setTimeout(verifyPayment, 2000);
        } else {
          // stop loading after all attempts fail
          setVerifying(false);
        }
      };
      if (easebuzzPaymentResponse && easebuzzPaymentResponse?.status === "success") {
        verifyPayment();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [easebuzzPaymentResponse]);
  
    const handleProceedGateway = (selectedGateway) => {
      if (selectedGateway === GATEWAY?.RAZORPAY) {
        //setIsPayViaEasebuzz(false)
        handleRazorPay(failedAmount)
        setFailedAmount('')
      }
      if (selectedGateway === GATEWAY?.EASEBUZZ) {
        //setIsPayViaEasebuzz(true)
        handleEasebuzzPay(failedAmount)
        setFailedAmount('')
      }
      setOpenPaymentFailedModal(false)
    }

  return (
    <Box
      sx={{ border: "1px solid rgba(26, 64, 125, 0.1)", borderRadius: "16px" }}
      p={3}
      mb={3}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setOpen(!open)}
      >
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          Payment Status
        </Typography>
        <img src={open ? shrinkIcon : expandIcon} alt="toggle-icon" />
      </Box>

      <Collapse in={open}>
        <Box mt={4}>
          <Grid container spacing={1} alignItems={"center"}>
            <Grid item xs={6}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {applicantData?.formPhase === FORM_PHASE.EOI ? "EOI" : "Voucher"} Amount
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "rgba(26, 64, 125, 1)",
                }}
              >
                {PaymentObject?.amountPayable
                  ? `₹${formatNumberIndian(PaymentObject.amountPayable)}`
                  : "₹0"}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                Amount Paid
              </Typography>
            </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "rgba(26, 64, 125, 1)",
                }}
              >
                {PaymentObject?.amountPaid
                  ? `₹${formatNumberIndian(PaymentObject.amountPaid)}`
                  : "₹0"}
              </Typography>
            </Grid>
          </Grid>

          <Divider sx={{ my: 1.5 }} />

          <Grid container mt={2} alignItems={"center"}>

              <Grid item xs={6}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  Balance Due
                </Typography>
              </Grid>
            <Grid item xs={6} textAlign="right">
              <Typography
                sx={{
                  fontSize: "20px",
                  fontWeight: 700,
                  color: "rgba(26, 64, 125, 1)",
                }}
              >
                {PaymentObject?.amountDue
                  ? `₹${formatNumberIndian(PaymentObject.amountDue)}`
                  : "₹0"}
              </Typography>
            </Grid>
          </Grid>

            <Grid
              container
              spacing={2}
              mt={2}
              alignItems="center"
              justifyContent="center"
              sx={{ flexWrap: "wrap" }}
            >
              {/* Input Field */}
            
                <Grid item xs={12}>
                  <TextFieldInput
                    field={{
                      placeholder: "Enter amount",
                      name: "amount",
                      required: false,
                      maxLength:15,
                      handleOnChange: (e) => {
                        const value = e.target.value;
                        const numericValue = value?.replace(/[^0-9]/g, "");
                        
                          paymentStatusformik.setFieldValue(
                            "amount",
                            numericValue
                          );
                          setPaymentAmount(value);
                        
                      },
                      readonly: false,
                    }}
                    formik={paymentStatusformik}
                  />
                </Grid>
              

              {/* Pay Button */}
              
                <Grid item xs={12}>
                  <Button
                    fullWidth
                    onClick={() => handleEasebuzzPay(paymentAmount)}
                    variant="contained"
                    sx={{
                      borderRadius: "8px",
                      fontWeight: 600,
                      textTransform: "none",
                      backgroundColor: "rgba(26, 64, 125, 1)",
                      fontSize: "14px",
                      "&:hover": {
                        backgroundColor: "rgba(26, 64, 125, 1)",
                      },
                      height:"40px", // consistent height
                    }}
                  >
                    Pay Now
                  </Button>
                </Grid>
              
            </Grid>
        
        </Box>
      </Collapse>
      <PaymentFailedModal open={openPaymentFailedModal} onClose={() => { setOpenPaymentFailedModal(false) }} onProceed={(selectedGateway) => { handleProceedGateway(selectedGateway) }} />
    </Box>
  );
};

export default PaymentStatus;